import { render, staticRenderFns } from "./campusSearch.vue?vue&type=template&id=31c382ea&scoped=true"
import script from "./campusSearch.vue?vue&type=script&lang=js"
export * from "./campusSearch.vue?vue&type=script&lang=js"
import style0 from "./campusSearch.vue?vue&type=style&index=0&id=31c382ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c382ea",
  null
  
)

export default component.exports